import { useEffect, useRef, useState } from 'react';
import {useParams} from 'react-router-dom';
import { Button } from '../../../Common/Button';
import { SearchSelect } from '../../../Common/Search/SearchSelect/SearchSelect';
import { post } from '../../../../Model/Network/Config/Axios';
import { showToast } from '../../../Common/Toast/index';
import { FunctionalInput } from '../../../Common/FloatInput/FunctionalInput';
import { RightModal } from '../../../Common/Modal/RightModal';
import { ProjectCustomTag } from '../../../Common/CustomTagging/Project';
import { AddRoles } from '../../../Common/Roles';


const AddTask = (props) => {

    const [buttonLoading,setButtonLoading] = useState(false);
    const [role,setRole] = useState(null);
    const {id} = useParams();
    let {item} = props;

    let TaskName=useRef(),TaskDetail=useRef(),TaskType=useRef(),Custom=useRef(),ROLES=useRef();

    useEffect(()=>{
        TaskName.current.value = item.taskName;
        TaskDetail.current.value = item.details;
        TaskType.current.setValue({value:item.taskType});
        if(item.role) {
            ROLES.current.setValue(item.role.name);
            setRole(item.role.id);
        }

    },[])


    let _addTask = () => {

        Custom.current.getValue(cb=>{

         
            let taskName = TaskName.current.value;
            if(!taskName) {
                showToast({
                    type:'error',
                    message:"Please enter the task Name"
                })
                return;
            }

            let taskDetails = TaskDetail.current.value;
            if (!taskDetails) {
                showToast({
                    type: 'error',
                    message: 'Please enter the task details'
                })
                return;
            }
            let taskType = TaskType.current.getValue();
            if (!taskType) {
                showToast({
                    type: 'error',
                    message: 'Please select the task type'
                })
                return;
            }
    
    
            let data = {
                taskId:item.id,
                taskDetails,
                taskType: taskType.value,
                roleId:role,
                taskName
            }
            if(cb && cb.length) {
                data.levelItemId = +cb[cb.length-1].levelId
            }
            setButtonLoading(true);
            post(`project/task/task.update`, data, (e, r) => {
                if (r) {
                    setButtonLoading(false);
                    showToast({
                        type: 'success',
                        message: 'Task Item Updated successfully'
                    })
                    props.onComplete()
                }
                if (e) {
                    showToast({
                        type: "error",
                        message: "error"
                    })
                    setButtonLoading(false)
                }
            })
    

        })

       
    }


    return (
            <RightModal
                show={true}
                onClose={props.onClose}
                title="Edit Task"
                desc="Fill up the all details and add task"
            >
                <ProjectCustomTag type="TASK" handleRef={ref=>Custom.current=ref}    />
                <FunctionalInput disabled={false} type="text" title="Task Name" ref={TaskName}/>
                <FunctionalInput type="text" title="Task Details" ref={TaskDetail} />
                <SearchSelect value={{value:item.taskType}} placeholder="Select Task Type" title="Task Type" handleRef={ref => TaskType.current = ref} items={[
                            {
                                key: 'REGULAR',
                                value: 'REGULAR'
                            },
                            {
                                key: 'IRREGULAR',
                                value: 'IRREGULAR'
                            }
                    ]} />
                <AddRoles title="Search Role (optional)" ref={ROLES} onSelect={(id)=>{
                    setRole(id)
                }} />

                <Button
                    text="Update Task"
                    style={{
                        marginTop: 20
                    }}
                    onClick={_addTask}
                    loading={buttonLoading}

                />

            </RightModal>
        )
}

export default AddTask